import { computed } from 'vue'
import { useOnboardingTooltipsStore } from '@src/pinia/tooltips'
import { storeToRefs } from 'pinia'

export function useOnboardingTooltips() {
  const onboardingTooltipsStore = useOnboardingTooltipsStore()

  const {
    currentTooltipId,
    currentTooltipIndex,
    overlayCutoutDimensionsOfCurrentTooltip,
    totalTooltipsOfCurrentFlow,
    currentTooltipFlow,
    isShowingTooltips
  } = storeToRefs(onboardingTooltipsStore)

  const {
    updateOverlayCutout,
    updateBreakpoint,
    nextOnboardingTooltip,
    nextEducationalTooltip
  } = onboardingTooltipsStore

  const isHighlighting = computed(() => !!currentTooltipId.value)

  function dismissOnboardingTooltips() {
    isShowingTooltips.value = false
  }

  function dismissEducationalTooltips() {
    isShowingTooltips.value = false
  }

  const dynamicCutoutCss = computed(() => ({
    top: `${overlayCutoutDimensionsOfCurrentTooltip.value.top}px`,
    left: `${overlayCutoutDimensionsOfCurrentTooltip.value.left}px`,
    padding: `${overlayCutoutDimensionsOfCurrentTooltip.value.height / 2}px ${overlayCutoutDimensionsOfCurrentTooltip.value.width / 2}px`
  }))

  return {
    currentTooltipId,
    currentTooltipIndex,
    overlayCutoutDimensionsOfCurrentTooltip,
    isHighlighting,
    totalTooltipsOfCurrentFlow,
    currentTooltipFlow,
    dynamicCutoutCss,
    updateOverlayCutout,
    updateBreakpoint,
    dismissEducationalTooltips,
    dismissOnboardingTooltips,
    nextOnboardingTooltip,
    nextEducationalTooltip
  }
}
